/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { NetworkPathSchema } from './networkPathSchema';
import type { ProfileDetailSchemaCertificationsItem } from './profileDetailSchemaCertificationsItem';
import type { ProfileDetailSchemaEducationItem } from './profileDetailSchemaEducationItem';
import type { ProfileDetailSchemaExperiencesItem } from './profileDetailSchemaExperiencesItem';
import type { ProfileDetailSchemaHighlights } from './profileDetailSchemaHighlights';
import type { ProfileDetailSchemaLanguagesItem } from './profileDetailSchemaLanguagesItem';
import type { ProfileDetailSchemaSocialProfilesItem } from './profileDetailSchemaSocialProfilesItem';
import type { TalentPoolRefSchema } from './talentPoolRefSchema';

export interface ProfileDetailSchema {
  profile_id: string;
  full_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  headline?: string | null;
  summary?: string | null;
  sex?: string | null;
  industry?: string | null;
  job_title?: string | null;
  job_company_name?: string | null;
  job_company_domain?: string | null;
  job_company_industry?: string | null;
  job_company_size?: string | null;
  job_company_founded?: number | null;
  job_start_date?: string | null;
  location_name?: string | null;
  location_country?: string | null;
  experiences?: ProfileDetailSchemaExperiencesItem[];
  education?: ProfileDetailSchemaEducationItem[];
  skills?: string[];
  languages?: ProfileDetailSchemaLanguagesItem[];
  certifications?: ProfileDetailSchemaCertificationsItem[];
  interests?: string[];
  highlights?: ProfileDetailSchemaHighlights;
  highlight_types?: string[] | null;
  social_profiles?: ProfileDetailSchemaSocialProfilesItem[];
  linkedin_url?: string | null;
  github_username?: string | null;
  twitter_url?: string | null;
  facebook_url?: string | null;
  has_personal_email?: boolean;
  has_work_email?: boolean;
  has_phone?: boolean;
  total_experience_months?: number | null;
  total_experience_years?: number | null;
  current_role_months?: number | null;
  avg_tenure_months?: number | null;
  years_experience?: string | null;
  current_tenure?: string | null;
  avatar_url?: string | null;
  ats_resume_parse_outcome?: string | null;
  talent_pool?: TalentPoolRefSchema | null;
  also_in_pools?: TalentPoolRefSchema[];
  network_paths?: NetworkPathSchema[];
}
